import script from "./uninstalled-terminal-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./uninstalled-terminal-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./uninstalled-terminal-drawer.vue?vue&type=style&index=0&id=5aca5b95&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aca5b95"]])

export default __exports__